import { CircularProgress, Typography } from '@material-ui/core';
import { useNotificationModal } from '@room-match/shared-ui-components'; // Remove Close Icon
import React, { createRef, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import CloseIcon from 'shared/components/Icon/CloseIcon'; // Use talent app level folder CloseIcon - Jerome
import MediaBinModal from 'shared/components/MediaBinModal/MediaBinModal';
import { PROFILE_LINKS_QUERY_STRING } from 'shared/constants/QUERY_STRING';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import IMedia from 'shared/interfaces/IMedia';
import { IProfileMediaSetSelectPayload } from 'shared/interfaces/IProfile';
import { setUser } from 'shared/redux/slicers/user.slicer';
import { useAppSelector } from 'shared/redux/store';
import { profileService } from 'shared/services/profileService';
import { errorResponseToArray } from 'shared/utils/room-shared';
import { FetchingCont } from '../../Resume/Resume.styles';
import { AddModalCont, BinContent, DropZone, ModalButton, ModalHeader } from './AddModal.styles';
import AudioBin from './AudioBin';
import ImageBin from './ImageBin';
import VideoBin from './VideoBin';

const { setSelectProfileMedia, getMediaProfile, setProfilePrimaryImage } = profileService();
interface Props {
  type: 'Images' | 'Videos' | 'Audio' | 'Documents';
  close: VoidFunction;
  openEditor?: (file: File[]) => void;
  isProfile?: boolean;
  isPrimaryProfile?: boolean;
  output?: (files: File[]) => void;
}

const invalidTypes = ['image', 'video', 'audio'];

const documentValidTypes = [
  'application/pdf',
  'text/plain',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

function AddModal({ type, close, openEditor, isProfile, output, isPrimaryProfile }: Props) {
  const dispatch = useDispatch();
  const { user: userState } = useAppSelector((state) => state);
  const { width } = useWindowDimensions();
  const { mutate } = setSelectProfileMedia();
  const { mutate: primaryImageMutate } = setProfilePrimaryImage();
  const { profileId } = useParams() as { profileId: string };
  const queryClient = useQueryClient();
  const [openBin, setOpenBin] = useState(false);
  const [loading, setloading] = useState(false);
  const [selected, setSelected] = useState<string[]>([]);
  const [medias, setmedias] = useState<IMedia[]>([]);
  const fileInput: any = createRef();
  const { data: imageData } = getMediaProfile(profileId, {
    file_type: 'image',
  });

  const { handleOpen, isOpen, NotificationModal, handleSetMessage, handleChangeModalType } = useNotificationModal({
    type: 'error',
  });

  const handleReturn = (medium: IMedia) => {
    const itemArr = selected;

    if (isProfile) {
      return setSelected([medium.id]);
    }

    const itemIndx = itemArr.indexOf(medium.id);
    if (itemIndx > -1) {
      //remove exist'
      itemArr.splice(itemIndx, 1);
    } else {
      //add item
      itemArr.push(medium.id);
    }

    setSelected([...itemArr]);
  };

  const binContent = () => {
    return (
      <BinContent>
        {type === 'Images' ? (
          <ImageBin updateItem={handleReturn} selected={selected} />
        ) : type === 'Videos' ? (
          <VideoBin updateItem={() => {}} />
        ) : (
          <AudioBin updateItem={() => {}} />
        )}
      </BinContent>
    );
  };

  const handleMakePrimary = (mediaId: string) => {
    const formData = new FormData();
    formData.set('medium_id', mediaId);
    primaryImageMutate(
      { profileId, formData },
      {
        onSuccess: (data) => {
          if (isPrimaryProfile) {
            dispatch(
              setUser({
                user: {
                  ...userState.user,
                  attributes: {
                    ...userState.user?.attributes,
                    picture: data.data.attributes.modified_attachment,
                  },
                },
              }),
            );
          }
          queryClient.removeQueries('profiles');
          queryClient.removeQueries(['profile_primary_image', profileId]);
          queryClient.invalidateQueries(['profile_media', profileId, { file_type: 'image' }]);
          queryClient.invalidateQueries(['profile', profileId]);
          queryClient.invalidateQueries(PROFILE_LINKS_QUERY_STRING.PROFILE_LIST, {
            refetchInactive: true,
          });
          close();
        },
      },
    );
  };

  const bindToProfile = (payload: IProfileMediaSetSelectPayload) => {
    mutate(
      {
        profileId,
        payload: { ...payload, sort: 0 },
      },
      {
        onSuccess: () => {
          setloading(false);
          handleMakePrimary(payload.id);
        },
        onError: (errors) => {
          if (errors?.response?.data?.errors) {
            const errorResponseArray: any = errorResponseToArray(errors.response.data.errors);
            console.error('error', errorResponseArray.join(','));
          } else {
            console.error('error', 'Something went wrong');
          }
          setloading(false);
        },
      },
    );
  };

  const handleAdd = () => {
    setloading(true);
    if (isProfile) {
      if (imageData?.data.find((f) => f.attributes.medium_id === selected[0])) {
        handleMakePrimary(selected[0]);
      } else {
        bindToProfile({
          id: selected[0],
          tag_list: 'image',
        });
      }
    }
  };

  const addMedia = (media: IMedia[]) => {
    setOpenBin(false);
    setloading(true);
    if (isProfile) {
      handleMakePrimary(media[0].id);
      // if (imageData?.data.find((f) => f.attributes.medium_id === media[0].id)) {
      // } else {
      //   bindToProfile({
      //     id: media[0].id,
      //     tag_list: 'image',
      //   });
      // }
    }
  };

  const processFiles = (files: File[]) => {
    let isIncorrectFile = false;
    let filteredFiles: File[] = [];

    const handleValidation = (
      files: File[],
      typeCheck: (file: File) => boolean,
      errorMessage: string,
      fileType: string,
    ) => {
      const filePromises = files.map((f) => {
        if (!typeCheck(f)) {
          isIncorrectFile = true;
          return console.error(`File is not ${errorMessage}`);
        }
        return Promise.resolve();
      });

      Promise.all(filePromises).then(() => {
        if (isIncorrectFile) {
          console.error(`File is not ${errorMessage}`);
          handleChangeModalType('error');
          handleSetMessage(
            'Invalid File',
            `${
              files.length > 1
                ? `One of the selected file is not a valid ${fileType} file format.`
                : `The selected file is not a valid ${fileType} file format.`
            }`,
            'OK',
          );
          handleOpen();
        } else {
          filteredFiles = files.filter(typeCheck);

          if (fileType === 'Image' && openEditor) {
            openEditor(filteredFiles);
          } else if (output) {
            output(filteredFiles);
          }

          close();
        }
      });
    };

    switch (type) {
      case 'Images':
        handleValidation(files, (f) => f.type.includes('image'), 'an image', 'Image');
        break;

      case 'Videos':
        handleValidation(files, (f) => f.type.includes('video'), 'video', 'Video');
        break;

      case 'Audio':
        handleValidation(files, (f) => f.type.includes('audio'), 'an audio', 'Audio');
        break;

      default:
        handleValidation(files, (f) => !invalidTypes.some((type) => f.type.includes(type)), 'a document', 'Document');

        // For documents, we need to use a different filter in the final stage
        // This will be overridden in the Promise.all callback
        filteredFiles = files.filter((f) => documentValidTypes.includes(f.type));
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop(acceptedFiles) {
      processFiles(acceptedFiles);
      console.log(acceptedFiles);
    },
  });

  const handleOnChange = async (e: any) => {
    const files: File[] = Array.from(e.target.files);
    if (files.length === 0) {
      return;
    }
    processFiles(files);
  };

  // return openBin ? (
  //   <BinCont>
  //     <CloseIcon
  //       style={{ width: 16, alignSelf: 'flex-end', marginBottom: 9, cursor: 'pointer' }}
  //       onClick={() => setOpenBin(false)}
  //     />
  //     <BinHeader>Select From Media Bin</BinHeader>
  //     {!isProfile && <SelectedContent>{selected.length} total items selected</SelectedContent>}
  //     {binContent()}
  //     <AddButton onClick={handleAdd} disabled={selected.length < 1 || loading}>
  //       {loading && <CircularProgress style={{ width: 23, height: 23, marginRight: 10, color: 'white' }} />}
  //       {isProfile ? 'Select Image' : `Add ${type}`}
  //     </AddButton>
  //   </BinCont>
  // ) : (
  return (
    <AddModalCont>
      {loading ? (
        <FetchingCont>
          <CircularProgress style={{ width: 23, height: 23, marginRight: 10 }} /> Uploading Media...
        </FetchingCont>
      ) : isProfile ? (
        <>
          <input
            accept={
              type === 'Images'
                ? 'image/*, .heic,.heif'
                : type === 'Videos'
                  ? 'video/*'
                  : type === 'Audio'
                    ? 'audio/*'
                    : '.txt,.pdf'
            }
            type="file"
            ref={fileInput}
            hidden
            onChange={handleOnChange}
          />
          <CloseIcon style={{ width: 16, alignSelf: 'flex-end', marginBottom: 9, cursor: 'pointer' }} onClick={close} />

          <ModalHeader>{isProfile ? 'Change Primary Image' : `Add ${type}`}</ModalHeader>
          <ModalButton onClick={() => setOpenBin(true)}>Select From Media Bin</ModalButton>

          <ModalButton style={{ marginBottom: 47 }} onClick={() => fileInput.current.click()}>
            Upload New {isProfile ? 'Image' : type}
          </ModalButton>
        </>
      ) : (
        <>
          <CloseIcon style={{ width: 16, alignSelf: 'flex-end', marginBottom: 9, cursor: 'pointer' }} onClick={close} />

          <ModalHeader>{isProfile ? 'Change Primary Image' : `Add ${type}`}</ModalHeader>
          <DropZone {...getRootProps({ className: 'dropzone' })}>
            <input {...getInputProps()} />
            {width > 960 ? (
              <Typography> Drop some {`${type}`} here, or click to select files</Typography>
            ) : (
              <Typography> Upload</Typography>
            )}
          </DropZone>
        </>
      )}
      {isOpen && <NotificationModal onClose={() => {}} />}
      {openBin ? (
        <MediaBinModal
          single
          showOnly={type === 'Audio' ? ['audio'] : type === 'Images' ? ['image'] : type === 'Videos' ? ['video'] : ['']}
          selected={medias}
          show={openBin}
          close={() => setOpenBin(false)}
          setSelected={addMedia}
        />
      ) : (
        <React.Fragment />
      )}
    </AddModalCont>
  );
  // );
}

export default AddModal;
